const GRADES = [
  {
    gwa: "1.00",
    remark: "Excellent",
    range: [97.5, 100],
    color: "premium",
  },
  {
    gwa: "1.25",
    remark: "Very Good",
    range: [94.5, 97.49],
    color: "green",
  },
  {
    gwa: "1.50",
    remark: "Very Good",
    range: [91.5, 94.49],
    color: "green",
  },
  {
    gwa: "1.75",
    remark: "Very Good",
    range: [86.5, 91.49],
    color: "green",
  },
  {
    gwa: "2.00",
    remark: "Satisfactory",
    range: [81.5, 86.49],
    color: "blue",
  },
  {
    gwa: "2.25",
    remark: "Satisfactory",
    range: [76.0, 81.49],
    color: "blue",
  },
  {
    gwa: "2.50",
    remark: "Satisfactory",
    range: [70.5, 75.99],
    color: "blue",
  },
  {
    gwa: "2.75",
    remark: "Fair",
    range: [65.0, 70.49],
    color: "yellow",
  },
  {
    gwa: "3.00",
    remark: "Fair",
    range: [59.5, 64.99],
    color: "yellow",
  },
  {
    gwa: "5.00",
    remark: "Failed",
    range: [0, 59.49],
    color: "red",
  },
];

export default GRADES;
